import { apiSlice } from '../../api/apiSlice';
import {
    EMPLOYEE_DAILY_METRIC_SUMMARY,
    EMPLOYEE_DAILY_METRIC_SUMMARY_EXPORT,
    EMPLOYEE_METRIC_STATUS,
    EMPLOYEE_METRIC_PAYOUT_STATUS,EMPLOYEE_SCORECARD_DAILY_METRIC_SUMMARY,
    MONTHLY_METRIC_SUMMARY,
    EMPLOYEE_TEAMLEAD_AGENTS,
    EMPLOYEE_USER_ACTIVITY_LOG,
    EMPLOYEE_METRIC_ALL_PAYOUTS,
    EMPLOYEE_PAYOUT_DETAILS,
    EMPLOYEE_PAYOUT_METRIC_ATTAINMENT,
    DISPUTE_UPDATE_REVIEW_STATUS,
    DISPUTE_GET_EMP_MONTHLY_RESULT_REVIEW_STATUS,
    AGENT_APPROVAL_STATUS_SEARCH,
    DISPUTE_RECALCULATE_ASSOCIATE,
    EMPLOYEE_MONTHLY_METRIC_HISTORY,
    GET_TEAM_MONTHLY_METRIC_VIEW,
    GET_TEAM_DAILY_METRIC_VIEW,
    GET_METRIC_TARGETS,
    PAYOUT_DAILY_DISPUTE_METRICS,
    EMPLOYEE_MONTHLY_METRIC_ATTAINMENT,
    EMPLOYEE_PAYOUT_LEVEL_METRIC_RATES
} from '../../constants';

export const metricDashboardSlice : any = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getEmployeeMetricStatus: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardRoleId } = arg;
                return {
                    url: EMPLOYEE_METRIC_STATUS,
                    params: { employeenumber, year, month, scorecardRoleId },
                };
            },
        }),
        getEmployeeMetricPayoutStatus: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month } = arg;
                return {
                    url: EMPLOYEE_METRIC_PAYOUT_STATUS,
                    params: { employeenumber, year, month },
                };
            },
        }),
        getMonthlyMetricsSummary: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId, scorecardRoleId } = arg;
                return {
                    url: MONTHLY_METRIC_SUMMARY,
                    params: { employeenumber, year, month, scorecardVersionId, scorecardRoleId },
                };
            },
            // keepUnusedDataFor:0,
        }),
        GetDailyMetricsTableDetails: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId, isPayoutMetric } = arg;
                return {
                    url: EMPLOYEE_SCORECARD_DAILY_METRIC_SUMMARY,
                    params: { employeenumber, year, month, scorecardVersionId, isPayoutMetric },
                };
            },
            providesTags: ['Disputes'],
            // keepUnusedDataFor:0,
        }),
        getDailyMetricsSummary: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId,scorecardRoleId,isFromCoachingAction } = arg;
                return {
                    url: EMPLOYEE_DAILY_METRIC_SUMMARY,
                    params: { employeenumber, year, month, scorecardVersionId,scorecardRoleId,isFromCoachingAction },
                };
            },
        }),
        getAgentData: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month } = arg;
                return {
                    url: EMPLOYEE_TEAMLEAD_AGENTS,
                    params: { employeenumber, year, month },
                };
            },
        }),
        getDailyMetricsSummaryExport: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId } = arg;
                return {
                    url: EMPLOYEE_DAILY_METRIC_SUMMARY_EXPORT,
                    params: { employeenumber, year, month, scorecardVersionId },
                };
            },
        }),
        getEmployeeMetricAllPayouts: builder.query({
            query: (arg: any) => {
                const { employeenumber,scorecardroleid } = arg;
                return {
                    url: EMPLOYEE_METRIC_ALL_PAYOUTS,
                    params: { employeenumber,scorecardroleid },
                };
            },
            providesTags: ['TeamPayoutApprovals'],
        }),
        getEmployeePayoutDetails: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month,scorecardversionid ,scorecardroleid} = arg;
                return {
                    url: EMPLOYEE_PAYOUT_DETAILS,
                    params: { employeenumber, year, month,scorecardversionid ,scorecardroleid},
                };
            },
        }),
        getPayoutMetricAttainment: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardversionid } = arg;
                return {
                    url: EMPLOYEE_PAYOUT_METRIC_ATTAINMENT,
                    params: { employeenumber, year, month, scorecardversionid },
                };
            },
        }),
        addUserActivityLog: builder.mutation({
            query: (arg: any) => {
                return {
                    url: EMPLOYEE_USER_ACTIVITY_LOG,
                    method: 'POST',
                    body: arg,
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                    },
                }
    
            },
            invalidatesTags: ['Post'],
        }),
        updateReviewStatus: builder.mutation({
            query: (arg: any) => ({
                url: DISPUTE_UPDATE_REVIEW_STATUS,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Disputes'],
        }),
        getEmpMonthlyResultReviewStatus: builder.query({
            query: (arg: any) => {
                const { employeeNumber, year, month,scorecardVersionId } = arg;
                return {
                    url: DISPUTE_GET_EMP_MONTHLY_RESULT_REVIEW_STATUS,
                    params: { employeeNumber, year, month,scorecardVersionId },
                };
            },
            providesTags: ['Disputes'],
        }),

        getAgentApprovalStatusSearch: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId } = arg;
                return {
                    url: AGENT_APPROVAL_STATUS_SEARCH,
                    params: { employeenumber, year, month, scorecardVersionId },
                };
            },
            providesTags: ['Disputes'],
        }),
        recalculateAssociate: builder.mutation({
            query: (arg: any) => ({
                url: DISPUTE_RECALCULATE_ASSOCIATE,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Disputes'],
        }),
        getMonthlyMetricHistory: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId, scorecardRoleId } = arg;
                return {
                    url: EMPLOYEE_MONTHLY_METRIC_HISTORY,
                    params: { employeenumber, year, month, scorecardVersionId, scorecardRoleId },
                };
            },
        }),
        getTeamMonthlyMetricView: builder.query({
            query: (arg: any) => {
                const { employeeNumber, year, month, scorecardVersionId, metricId } = arg;
                return {
                    url: GET_TEAM_MONTHLY_METRIC_VIEW,
                    params: { employeeNumber, year, month, scorecardVersionId, metricId },
                };
            },
        }),
        getTeamDailyMetricView: builder.query({
            query: (arg: any) => {
                const { employeeNumber, scorecardVersionId, metricId, resultDate } = arg;
                return {
                    url: GET_TEAM_DAILY_METRIC_VIEW,
                    params: { employeeNumber, scorecardVersionId, metricId, resultDate },
                };
            },
        }),
        getMetricTargets: builder.query({
            query: (arg: any) => {
                const { AgentNumber,SupervisorNumber,Year,Month,ScorecardVersionId,MetricId} = arg;
                return {
                    url: GET_METRIC_TARGETS,
                    params: { AgentNumber,SupervisorNumber,Year,Month,ScorecardVersionId,MetricId },
                };
            },
        }),
        getPayoutDailyDisputeMetrics: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId } = arg;
                return {
                    url: PAYOUT_DAILY_DISPUTE_METRICS,
                    params: { employeenumber, year, month, scorecardVersionId },
                };
            },
        }),
        getEmpMonthlyMetricAttainment: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId } = arg;
                return {
                    url: EMPLOYEE_MONTHLY_METRIC_ATTAINMENT,
                    params: { employeenumber, year, month, scorecardVersionId },
                };
            },
        }),
        getEmpPayoutLevelMetricRates: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId } = arg;
                return {
                    url: EMPLOYEE_PAYOUT_LEVEL_METRIC_RATES,
                    params: { employeenumber, year, month, scorecardVersionId },
                };
            },
        }),
    }),
});

export const {
    useGetEmployeeMetricStatusQuery,
    useGetEmployeeMetricPayoutStatusQuery,
    useGetMonthlyMetricsSummaryQuery,
    useGetDailyMetricsTableDetailsQuery,
    useGetDailyMetricsSummaryQuery,
    useGetAgentDataQuery,
    useGetDailyMetricsSummaryExportQuery,
    useGetEmployeeMetricAllPayoutsQuery,
    useGetEmployeePayoutDetailsQuery,
    useGetPayoutMetricAttainmentQuery,
    useUpdateReviewStatusMutation,
    useAddUserActivityLogMutation,
    useGetEmpMonthlyResultReviewStatusQuery,
    useGetAgentApprovalStatusSearchQuery,
    useRecalculateAssociateMutation,
    useGetMonthlyMetricHistoryQuery,
    useGetTeamMonthlyMetricViewQuery,
    useGetTeamDailyMetricViewQuery,
    useGetMetricTargetsQuery,
    useGetPayoutDailyDisputeMetricsQuery,
    useGetEmpMonthlyMetricAttainmentQuery,
    useGetEmpPayoutLevelMetricRatesQuery,
} = metricDashboardSlice;
